var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditGreenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2626 4.52112H4.37433C3.85236 4.52112 3.35177 4.72847 2.98269 5.09756C2.6136 5.46664 2.40625 5.96723 2.40625 6.4892V20.2658C2.40625 20.7877 2.6136 21.2883 2.98269 21.6574C3.35177 22.0265 3.85236 22.2338 4.37433 22.2338H18.1509C18.6729 22.2338 19.1735 22.0265 19.5425 21.6574C19.9116 21.2883 20.119 20.7877 20.119 20.2658V13.3775",
    stroke: "#67CCB2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.643 3.04506C19.0344 2.65358 19.5654 2.43365 20.119 2.43365C20.6727 2.43365 21.2036 2.65358 21.5951 3.04506C21.9866 3.43653 22.2065 3.96749 22.2065 4.52112C22.2065 5.07475 21.9866 5.6057 21.5951 5.99718L12.2467 15.3456L8.31055 16.3296L9.29459 12.3934L18.643 3.04506Z",
    stroke: "#67CCB2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGreenIcon);
export default __webpack_public_path__ + "static/media/editGreenIcon.bd0408aea66cfa1b68cd971fe9ec962b.svg";
export { ForwardRef as ReactComponent };